module.exports = __webpack_public_path__ + "media/assets/images/landing/мун. недвижимость-cf6185221fa8db5b2cfef46bce94794f.png";